import { Card, CardHeader, CardContent, CardProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ReactNode } from "react";

const StyledCard = styled(Card)(({ theme }) => ({
  display: "none",
  [theme.breakpoints.up("md")]: {
    display: "block",
  },
  order: -1,
  flex: "0 0 15em",
  marginRight: theme.spacing(2),
  alignSelf: "flex-start",
  boxShadow: theme.shadows[1],

  // Header styling
  "& .MuiCardHeader-root": {
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1.9),
  },

  // Content styling
  "& .MuiCardContent-root": {
    padding: theme.spacing(2),

    // Filter sections spacing
    "& .MuiList-root": {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },

    // Search input
    "& .RaFilterLiveSearch": {
      marginBottom: theme.spacing(2),
    },
  },
}));

interface StyledListAsideProps extends Omit<CardProps, "title"> {
  title?: string;
  children: ReactNode;
}

export const StyledListAside = ({ title = "Filters", children, ...props }: StyledListAsideProps) => {
  return (
    <StyledCard {...props}>
      <CardHeader title={title} />
      <CardContent>{children}</CardContent>
    </StyledCard>
  );
};
